/*
    Element gives ability to select currency for the quote
    Based on the currency selection it also updated the Summary element with the correct price
 */

import React, {useEffect} from 'react'
import { useSelector, useDispatch } from "react-redux";
import {setCurrency, setPriceBook} from "../store/details/projectDetailsSlice";
import {getSummary} from "../store/summarySlice";


/*

    As of 624 customizeable currency has been removed from the front end.
    See https://gitlab.com/mediumrare/fluxwerx/configurator/-/issues/624#note_2033826573

    Currency selector is a dropdown to choose in which currency we want to show pricing. It only appears for Admins,
    it also pre-fills based on agents default currency
 */
const CurrencySelector = (props) => {
        const dispatch = useDispatch();
        const quoteItemId = useSelector(state => state.projectDetailsReducer.quoteItemId);
        const groupId = useSelector(state => state.patternDetailsReducer.groupId);
        const agent = useSelector(state => state.agent);
        const currency = useSelector(state => state.projectDetailsReducer.currency);
        const priceBook = useSelector(state =>state.projectDetailsReducer.priceBook)

    
    useEffect(() => {
        const isNewPage =  quoteItemId == "" && groupId == "";
        // this is done first time when currency selector loads, and only for a new page
        // we need this to sync currency with agent default currency
       if(isNewPage && agent != "") {
           dispatch(setCurrency(agent.default_currency));
       }
    }, [agent])

    const languageSelect = () => {
            return <>language</>
    }

    return (
        <div className="row" key={agent.default_currency}>
            <div className="small-3 columns">
            </div>
            <div className="small-9 columns">
                <div>
                    <label>Currency: </label>
                    <span>{agent.default_currency}</span>
                </div>
                <div>
                    <label>Price Book:</label>
                    <span>
                        {priceBook}
                    </span>
                </div>
                <div>
                    <label>Languages:</label>
                    {/*<span>*/}
                    {/*    {languageSelect()}*/}
                    {/*</span>*/}
                </div>
            </div>
        </div>
    )

}

export default CurrencySelector;